import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M6.66732 9.1665C6.66732 8.70627 7.04041 8.33317 7.50065 8.33317H12.5007C12.9609 8.33317 13.334 8.70627 13.334 9.1665C13.334 9.62674 12.9609 9.99984 12.5007 9.99984H7.50065C7.04041 9.99984 6.66732 9.62674 6.66732 9.1665Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M7.50065 11.6665C7.04041 11.6665 6.66732 12.0396 6.66732 12.4998C6.66732 12.9601 7.04041 13.3332 7.50065 13.3332H10.834C11.2942 13.3332 11.6673 12.9601 11.6673 12.4998C11.6673 12.0396 11.2942 11.6665 10.834 11.6665H7.50065Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.9175 2.49984C12.5374 1.99382 11.9322 1.6665 11.2507 1.6665H8.75065C8.06906 1.6665 7.46392 1.99382 7.08383 2.49984H5.83398C4.45327 2.49984 3.33398 3.61913 3.33398 4.99984V14.9998C3.33398 16.3805 4.45327 17.4998 5.83398 17.4998H14.1673C15.548 17.4998 16.6673 16.3805 16.6673 14.9998V4.99984C16.6673 3.61913 15.548 2.49984 14.1673 2.49984H12.9175ZM8.33398 3.74984C8.33398 3.51972 8.52053 3.33317 8.75065 3.33317H11.2507C11.4808 3.33317 11.6673 3.51972 11.6673 3.74984C11.6673 3.97996 11.4808 4.1665 11.2507 4.1665H8.75065C8.52053 4.1665 8.33398 3.97996 8.33398 3.74984ZM6.70899 4.1665H5.83398C5.37375 4.1665 5.00065 4.5396 5.00065 4.99984V14.9998C5.00065 15.4601 5.37375 15.8332 5.83398 15.8332H14.1673C14.6276 15.8332 15.0007 15.4601 15.0007 14.9998V4.99984C15.0007 4.5396 14.6276 4.1665 14.1673 4.1665H13.2923C13.0993 5.11744 12.2586 5.83317 11.2507 5.83317H8.75065C7.74275 5.83317 6.90202 5.11744 6.70899 4.1665Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
  ]))
}